import { render, staticRenderFns } from "./addEffectDialog.vue?vue&type=template&id=770e5956&scoped=true&"
import script from "./addEffectDialog.vue?vue&type=script&lang=js&"
export * from "./addEffectDialog.vue?vue&type=script&lang=js&"
import style0 from "./addEffectDialog.vue?vue&type=style&index=0&id=770e5956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e5956",
  null
  
)

export default component.exports